import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import HeroImage from './HeroImage'

const copy = {
  overline: `Audiences`,
  heading: `Build once, activate precise audiences everywhere`,
  description: `Tap into the full potential of your campaigns using targeted, real-time audiences accessible across all platforms.`,
  buttonText: `Get a demo`,
}

const Hero = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline variant="overline" tag="span">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="h2">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier="site-engage-audiences-demo"
              customTrackingType="site-engage-audiences-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroImage />
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  position: relative;
  z-index: 0;
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
